import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectRepresentanteCLIComponent, MultiSelectRepresentanteIFComponent, SelectBancoComponent, SelectBancoIFComponent, SelectComprobanteContabilizadoComponent, SelectComprobanteEmitidoComponent, SelectCondicionComponent, SelectDetraccionBaseComponent, SelectEntidadFinancieraComponent, SelectFondoGarantiaBaseComponent, SelectIgvExoneradoComponent, SelectMonedaComponent, SelectParticipanteComponent, SelectRetencionBaseComponent, SelectRetencionComponent, SelectRolContactoComponent, SelectRutTitularComponent, SelectTipoAdjuntoComponent, SelectTipoComprobanteComponent, SelectTipoComprobanteIFComponent, SelectTipoConformidadComponent, SelectTipoContactoComponent, SelectTipoCuentaComponent, SelectTipoDocumentoComponent, SelectTipoEmisionComponent, SelectTipoFacturacion, SelectTipoOperacionComponent, SelectTipoOperacionNCComponent, SelectTipoOperacionNDComponent, SelectTipoPagoComponent, SelectTipoPagoCPEComponent, SelectTipoPlanillaComponent, SelectTipoServicioComponent, SelectTipoSolicitudComponent, SelectTipoXlsComponent } from './componentes-globales.component';
import { MatSelectModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  declarations: [
    SelectTipoOperacionNDComponent,
    SelectMonedaComponent,
    SelectBancoComponent,
    SelectTipoPagoComponent,
    SelectTipoContactoComponent,
    SelectTipoDocumentoComponent,
    SelectIgvExoneradoComponent,
    SelectRolContactoComponent,
    SelectTipoCuentaComponent,
    SelectTipoComprobanteComponent,
    SelectTipoComprobanteIFComponent,
    SelectComprobanteEmitidoComponent,
    SelectComprobanteContabilizadoComponent,
    SelectCondicionComponent,
    SelectTipoConformidadComponent,
    SelectTipoEmisionComponent,
    SelectFondoGarantiaBaseComponent,
    SelectDetraccionBaseComponent,
    SelectRetencionBaseComponent,
    SelectRetencionComponent,
    SelectTipoXlsComponent,
    SelectTipoPlanillaComponent,
    SelectBancoIFComponent,
    SelectParticipanteComponent,
    SelectRutTitularComponent,
    SelectTipoSolicitudComponent,
    SelectTipoAdjuntoComponent,
    SelectTipoOperacionComponent,
    SelectTipoPagoCPEComponent,
    SelectTipoOperacionNCComponent,
    SelectTipoServicioComponent,
    SelectEntidadFinancieraComponent,
    SelectTipoFacturacion,
    MultiSelectRepresentanteIFComponent,
    MultiSelectRepresentanteCLIComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    AngularMultiSelectModule
  ],
  exports: [
    SelectTipoOperacionNDComponent,
    SelectMonedaComponent,
    SelectBancoComponent,
    SelectTipoPagoComponent,
    SelectTipoContactoComponent,
    SelectTipoDocumentoComponent,
    SelectIgvExoneradoComponent,
    SelectRolContactoComponent,
    SelectTipoCuentaComponent,
    SelectTipoComprobanteComponent,
    SelectTipoComprobanteIFComponent,
    SelectComprobanteEmitidoComponent,
    SelectComprobanteContabilizadoComponent,
    SelectCondicionComponent,
    SelectTipoConformidadComponent,
    SelectTipoEmisionComponent,
    SelectFondoGarantiaBaseComponent,
    SelectDetraccionBaseComponent,
    SelectRetencionBaseComponent,
    SelectRetencionComponent,
    SelectTipoXlsComponent,
    SelectTipoPlanillaComponent,
    SelectBancoIFComponent,
    SelectParticipanteComponent,
    SelectRutTitularComponent,
    SelectTipoSolicitudComponent,
    SelectTipoAdjuntoComponent,
    SelectTipoOperacionComponent,
    SelectTipoPagoCPEComponent,
    SelectTipoOperacionNCComponent,
    SelectTipoServicioComponent,
    SelectEntidadFinancieraComponent,
    SelectTipoFacturacion,
    MultiSelectRepresentanteIFComponent,
    MultiSelectRepresentanteCLIComponent,
  ]
})
export class ComponentesGlobalesModule { }
